export default "__VITE_ASSET__45c9b0c0__"